module.exports = __webpack_public_path__ + "img/dentist-men.a22942a2.png";